import {
	AuthenticatedTemplate,
	UnauthenticatedTemplate,
	useMsal,
} from '@azure/msal-react';
import { Route, Routes } from 'react-router-dom';
import { Auth } from './components/Auth';
import { BulkSearch } from './components/BulkSearch';
import { ManualTranslations } from './components/ManualTranslations';
import { Lookup } from './components/Lookup';
import { Overrides } from './components/Overrides';
import { Root } from './components/Root';
import { BulkImport } from '~src/frontend/components/BulkImport';
import { useSessionGuard } from '~src/frontend/hooks/useAuth';
import { loginRequest } from '~src/frontend/lib/auth';

export const App = () => {
	const { instance } = useMsal();
	const activeAccount = instance.getActiveAccount();

	useSessionGuard();

	const handleRedirect = () => {
		instance
			.loginRedirect({
				...loginRequest,
				prompt: 'create',
			})
			.catch((error) => console.log(error));
	};

	return (
		<>
			<AuthenticatedTemplate>
				{activeAccount ? (
					<Routes>
						<Route path="/" element={<Root />} />
						<Route path="/override" element={<Overrides />} />
						<Route
							path="/manual-translation"
							element={<ManualTranslations />}
						/>
						<Route path="/bulk-search" element={<BulkSearch />} />
						<Route path="/bulk-import" element={<BulkImport />} />
						<Route path="/lookup" element={<Lookup />} />
					</Routes>
				) : null}
			</AuthenticatedTemplate>
			<UnauthenticatedTemplate>
				<div className="sign-in-page">
					<div className="sign-in-panel">
						<h1>Translation Override Manager</h1>
						<p>Sign in to continue</p>
						<button className="sign-in-button" onClick={handleRedirect}>
							Sign in
						</button>
					</div>
				</div>
			</UnauthenticatedTemplate>
		</>
	);
};
